"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _NativeSelect = require("./NativeSelect");
var _CustomSelect = require("./CustomSelect");
var _Option = require("./Option");
var _excluded = ["children", "disabled", "descriptionStyles", "desktopStyles", "isDesktopView", "label", "labelStyles", "mobileStyles", "onChange", "onBlur", "placeholder", "value", "inputWrapperStyles", "iconStyles", "wrapperStyles"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var SelectInputRef = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    descriptionStyles = _ref.descriptionStyles,
    desktopStyles = _ref.desktopStyles,
    _ref$isDesktopView = _ref.isDesktopView,
    isDesktopView = _ref$isDesktopView === void 0 ? false : _ref$isDesktopView,
    label = _ref.label,
    labelStyles = _ref.labelStyles,
    mobileStyles = _ref.mobileStyles,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? _lodash.noop : _ref$onBlur,
    placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    inputWrapperStyles = _ref.inputWrapperStyles,
    iconStyles = _ref.iconStyles,
    wrapperStyles = _ref.wrapperStyles,
    props = _objectWithoutProperties(_ref, _excluded);
  // Ensure children is a flat array
  var childArray = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children);
  }, [children]);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    error = _useInputValidation.error,
    validateOnBlur = _useInputValidation.validateOnBlur;
  var handleBlur = function handleBlur(e) {
    validateOnBlur();
    onBlur(e);
  };
  var description = error || '';
  var showNativeSelect = (0, _utils.isMobile)() && !isDesktopView;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex flex-col', {
      'select-input-invalid': error && !disabled
    }, wrapperStyles)
  }, showNativeSelect ? /*#__PURE__*/_react.default.createElement(_NativeSelect.NativeSelect, _extends({
    ref: ref,
    children: (0, _lodash.compact)([placeholder && /*#__PURE__*/_react.default.createElement(_Option.Option, {
      value: "",
      key: placeholder,
      disabled: true
    }, placeholder)].concat(_toConsumableArray(childArray))),
    disabled: disabled,
    error: error,
    label: label,
    onChange: onChange,
    onBlur: handleBlur,
    value: value
  }, mobileStyles, props)) : /*#__PURE__*/_react.default.createElement(_CustomSelect.CustomSelect, _extends({
    children: childArray,
    disabled: disabled,
    error: error,
    label: label,
    labelStyles: labelStyles,
    inputWrapperStyles: inputWrapperStyles,
    iconStyles: iconStyles,
    onChange: onChange,
    onBlur: handleBlur,
    ref: ref,
    value: value,
    placeholder: label ? undefined : placeholder
  }, desktopStyles, props)), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('select-input-description tw-caption-regular ml-[2px] inline-block', 'pointer-events-none',
    // Used to animate description appearance
    description ? 'mt-[6px] h-[17px]' : 'mt-0 h-0', descriptionStyles),
    id: "".concat((0, _lodash.kebabCase)(label), "-description")
  }, description));
});
var SelectInput = Object.assign(SelectInputRef, {
  Option: _Option.Option
});
exports.SelectInput = SelectInput;